import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import ContentView from './ContentView';
import ContentEdit from './ContentEdit';

const Content = (props) => {
  const [mode, setMode] = React.useState(null);

  const modeParent = props.mode;

  React.useEffect(() => {
    if (modeParent) {
      setMode(modeParent);
    } else {
      setMode('VIEW');
    }
  }, [modeParent]);

  if (mode === 'VIEW') {
    return (
      <Box>
        <ContentView
          {...props}
          setEditMode={() => setMode('EDIT')}
        />
      </Box>
    );
  } else if (mode === 'EDIT') {
    return (
      <Box>
        <ContentEdit
          {...props}
          setViewMode={() => setMode('VIEW')}
        />
      </Box>
    );
  } else if (mode === 'new') {
    return (
      <Box>
        <ContentEdit
          {...props}
          setViewMode={() => setMode('VIEW')}
        />
      </Box>
    );
  } else {
    return null;
  }
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  mode: PropTypes.string,
};
export default React.memo(Content);
